import React from 'react';
import {
  Button,
  Alert,
  Popover,
  Modal,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Row,
  Col,
  FormGroup,
  Input,
  Label,
  Progress,
  InputGroup,
  InputGroupAddon,
} from 'reactstrap';
import $ from 'jquery';
import { withAlert } from 'react-alert';
import { connect } from 'react-redux';
import ValidatedTextBox from '../ValidatedTextBox';
import { Flag } from 'flagger/react';
import DocumentTypeValidationModal from './DocumentTypeValidationModal';

class NewDocumentTypeConfigModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      type: '',
      lang: '',
      documentArea: '',
      documentTypeModalVisible: false,
      documentTypeValidationModalVisible: false,
      documentTypeConfigArray: [],
      documentTypes: [],
      hierarchyTypes: {},
      parentHierarchies: [{}],
      childHierarchies: [{}],
      errorMessage: '',
      folders: [],
      fieldsarray: [], // Initialize fieldsarray as an empty array
      includeSagePay: false
    };

    this.handleDropdownChange = this.handleDropdownChange.bind(this);
    this.toggleDocumentTypeConfigModal =
      this.toggleDocumentTypeConfigModal.bind(this);
    this.validateDocumemtType = this.validateDocumemtType.bind(this);
    this.handlePrintDropdownChange = this.handlePrintDropdownChange.bind(this);
    this.includeSagePayCheckChange = this.includeSagePayCheckChange.bind(this);
    this.remove = this.remove.bind(this);
  }

  validateDocumemtType() {
    var valid = true;

    if (!this.state.documentType) {
      this.setState({
        errorMessage: 'Document type required, please enter value',
      });
      return;
    }
    if (!this.state.folder) {
      this.setState({ errorMessage: 'Folder required, please enter value' });
      return;
    }
    if (!this.state.description) {
      this.setState({
        errorMessage: 'Document type description required, please enter value',
      });
      return;
    }
    if (!this.state.transaction_type) {
      this.setState({
        errorMessage: 'Transaction type required, please enter a value',
      });
      return;
    }
    if (
      this.state.documentArea == 'attachment' &&
      this.state.parentHierarchies.length === 0
    ) {
      this.setState({
        errorMessage: 'Parent Document Type required for attachment',
      });
      return;
    }

    // if(!this.state.documentTypeConfigArray && this.state.documentTypeConfigArray.length == 0)
    // {
    //   this.setState({ errorMessage :"Document type already exists, please enter different value" });
    //   return;
    // }
    // else if(this.state.documentTypeConfigArray[0].name === "")
    // {
    //   this.setState({ errorMessage :"Document type already exists, please enter different value" });
    //   return;
    // }

    const found = this.state.documentTypes.find((element) => {
      return (
        this.state.documentType == element.DocumentType &&
        this.state.folder == element.Folder
      );
    });

    //check valid items
    if (found) {
      this.setState({
        errorMessage:
          'Document type already exists, please enter different value',
      });
      return;
    } else {
      //TODO: check that the document doesn't already exist.
      // this.addNewDocumentType(this.state.documentType, this.state.description, this.state.transaction_type,this.state.documentTypeConfigArray, this.state.hierarchyTypes)
      var body = {};
      body.documentType = this.state.documentType;
      body.description = this.state.description;
      body.transactionType = this.state.transaction_type;
      body.scanId = this.state.scan_id;
      body.fields = this.state.documentTypeConfigArray;
      body.hierarchy = this.state.hierarchyTypes;
      body.documentArea = this.state.documentArea;
      body.folder = this.state.folder;

      if (this.state.childHierarchies.length > 0 && Object.keys(this.state.childHierarchies[0]).length > 0) {

        body.hierarchy.childDocTypes = this.state.childHierarchies;
      }

      if (this.state.parentHierarchies.length > 0 && Object.keys(this.state.parentHierarchies[0]).length > 0) {

        body.hierarchy.parentDocTypes = this.state.parentHierarchies;
      } 

      fetch(
        window.location.protocol +
          '//' +
          window.location.host +
          '/api/configuration/documentType',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        }
      )
        .then((res) => res.json())
        .then((result) => {
          //this.props.alert.success("Created document type");
          this.props.refresh();
          this.props.toggle();
        });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selectedPrintClient != this.state.selectedPrintClient) {
      this.formIsLoading();
    }

    if (this.state.folder != prevState.folder) {
      this.setState({
        documentTypes: []
      })
      this.getDocumentTypes();
    }
  }

  componentDidMount() {
    this.formIsLoading();
    var newArray = this.state.documentTypeConfigArray.slice();
    var printerObj = {
      id: 0,
      Name: '',
      Description: '',
      Type: '',
    };
    newArray.push(printerObj);

    this.getDocumentTypes();
    this.getX3Folders();

    this.setState({ documentTypeConfigArray: newArray, isLoading: false });

    if (this.props.isCopy) {
      this.fetchCopy();
    }
  }

  fetchCopy = () => {
    fetch(
      window.location.protocol +
        '//' +
        window.location.host +
        '/api/configuration/documentType?id=' +
        this.props.destination
    )
      .then((res) => res.json())
      .then((result) => {
        let useSagePay;
        const fieldsArray = []; // Use a local array to collect fields

        result.Fields.forEach((field, i) => {
          const fieldObj = {
            id: i,
            Name: field.Name,
            Description: field.Description.en,
            Type: field.Type,
          };

          if (field.Name.startsWith('payitnow')) {
            useSagePay = true; // Mark that SagePay fields are included
          }

          fieldsArray.push(fieldObj); // Add each field to the local array
        });

        // Update the state with the fields array and SagePay status
        this.setState({
          fieldsarray: fieldsArray,
          includeSagePay: useSagePay,
          documentTypeConfigArray: fieldsArray,
        });

        let parentHierarchies = [];
        let childHierarchies = [];

        if (
          result.hierarchy &&
          result.hierarchy.parentDocTypes &&
          result.hierarchy.parentDocTypes.length > 0
        ) {
          parentHierarchies = [...result.hierarchy.parentDocTypes];
        } else {
          parentHierarchies.push({});
        }

        if (
          result.hierarchy &&
          result.hierarchy.childDocTypes &&
          result.hierarchy.childDocTypes.length > 0
        ) {
          childHierarchies = [...result.hierarchy.childDocTypes];
        } else {
          childHierarchies.push({});
        }

        this.setState({
          documentType: result.DocumentType,
          destinatdocumentTypeConfigion: result,
          description: result.Description.en,
          transaction_type: result.TransactionType,
          folder: result.Folder,
          scan_id: result.ScanID,
          documentArea: result.DocumentArea,
          hierarchy: result.hierarchy || {},
          isLoading: false,
          childHierarchies,
          parentHierarchies,
        });
      });
  };

  formIsLoading() {
    this.setState({ isLoading: true });
  }

  getX3Folders = async () => {
    try {
      const r = await fetch(`${window.location.origin}/api/sageX3/get_x3_folders`, {
        headers: { "Accept": "application/json" }
      });

      const payload = await r.json();

      if (!r.ok) {
        console.error("get_X3_folders failed", payload);
        this.setState({ isLoading: false });
        return;
      }

      this.setState({
        folders: payload?.folders ?? [],
        isLoading: false
      });
    } catch (err) {
      console.error("get_X3_folders error", err);
      this.setState({ isLoading: false });
    }
  };

  getDocumentTypes = () => {
    fetch(window.location.protocol + '//' + window.location.host + '/api/configuration/documentTypes?folder=' + this.state.folder)
      .then((res) => res.json())
      .then((result) => {
        this.setState({
          documentTypes: result,
        });
      });
  };

  handleDropdownChange = (valid, event) => {
    const target = event.target;
    const value = target.value;
    const name = target.id;
    this.setState({ [name]: value });
  };

  handleFolderDropdownChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.id;
    this.setState({
      [name]: value,
    });
  };

  handleDocumentAreaDropdownChange = (event) => {
    this.setState({
      documentArea: event.target.value,
    });
  };

  handlePrintDropdownChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    const id = target.id;

    var found = this.state.documentTypeConfigArray.find((element) => {
      return element.id == id;
    });

    if (!this.state.documentTypeConfigArray.includes(found)) {
      var printerObj = {
        id: this.state.documentTypeConfigArray.length,
        Name: '',
        Description: '',
        Type: '',
      };

      this.setState((prevState) => ({
        documentTypeConfigArray:
          prevState.documentTypeConfigArray.concat(printerObj),
      }));
    } else {
      found[name] = value;

      var newArray = this.state.documentTypeConfigArray;
      newArray.splice(id, 1, found);

      this.setState({
        documentTypeConfigArray: newArray,
      });
    }
  }

  toggleDocumentTypeConfigModal() {
    var newArray = this.state.documentTypeConfigArray.slice();
    var printerObj = {
      id: this.state.documentTypeConfigArray.length,
      Name: '',
      Description: '',
      Type: '',
    };
    newArray.push(printerObj);
    this.setState({ documentTypeConfigArray: newArray });
  }

  toggleDocumentTypeValidationModal = () => {
    this.setState({
      documentTypeValidationModalVisible:
        !this.state.documentTypeValidationModalVisible,
    });
  };

  remove(id) {
    // create new array and re-assign ids on remove
    var newArray = [];
    var newid = 0;

    this.state.documentTypeConfigArray.forEach((documentTypeConfig, i) => {
      if (i != id) {
        var documentObj = {
          id: newid,
          Name: documentTypeConfig.Name,
          Description: documentTypeConfig.Description,
          Type: documentTypeConfig.Type,
        };
        newArray.push(documentObj);
        newid++;
      }
    });

    this.setState({ documentTypeConfigArray: newArray });
  }

  handleHierarchyCheckChange = (e, i) => {
    const name = e.target.name;
    const value = e.target.checked;

    let hierarchy = this.state.hierarchyTypes[i];
    hierarchy[name] = value;

    this.setState({
      hierarchyTypes: hierarchy,
    });
  };

  handleParentHierarchyChange = (e, i) => {
    const name = e.target.name;
    const value = e.target.value;
    const partsArray = value.split('!'); // Split the selected value into an array

    let hierarchy = [...this.state.parentHierarchies];

    if (partsArray.length === 2) {
      const id = partsArray[0];
      const docType = partsArray[1];
      
      hierarchy[i][name] = docType;
      hierarchy[i]['id'] = id;
    }
    else if (partsArray.length === 3) {
      const id = partsArray[0];
      const docType = partsArray[1];
      const field = partsArray[2];

      hierarchy[i][name] = docType;
      hierarchy[i]['id'] = id;
      hierarchy[i]['field'] = field;
    }

    this.setState({
      parentHierarchies: hierarchy
    })
  }

  handleParentHierarchyCheckChange = (e, i) => {
    const name = e.target.name;
    const value = e.target.checked;

    let hierarchy = [...this.state.parentHierarchies];
    hierarchy[i][name] = value;

    this.setState({
      parentHierarchies: hierarchy,
    });
  };

  handleChildHierarchyChange = (e, i) => {
    const name = e.target.name;
    const value = e.target.value;
    const partsArray = value.split('!'); // Split the selected value into an array

    let hierarchy = [...this.state.childHierarchies];

    if (partsArray.length === 2) {
      const id = partsArray[0];
      const docType = partsArray[1];

      hierarchy[i][name] = docType;
      hierarchy[i]['id'] = id;
    }
    else if (partsArray.length === 3) {
      const id = partsArray[0];
      const docType = partsArray[1];
      const field = partsArray[2];

      hierarchy[i][name] = docType;
      hierarchy[i]['id'] = id;
      hierarchy[i]['field'] = field;
    }

    this.setState({
      childHierarchies: hierarchy,
    });
  };

  handleChildHierarchyCheckChange = (e, i) => {
    const name = e.target.name;
    const value = e.target.checked;

    let hierarchy = [...this.state.childHierarchies];
    hierarchy[i][name] = value;

    this.setState({
      childHierarchies: hierarchy,
    });
  };

  includeSagePayCheckChange = (e) => {
    //add the specific sage pay fields
    const name = e.target.name;
    const value = e.target.checked;
    if (value) {
      //add the sage pay meta fields.

      var newArray = this.state.documentTypeConfigArray.slice();

      var payitnow_Ref = {
        id: newArray.length,
        Name: 'payitnow_Ref',
        Description: 'Pay it now Reference',
        Type: 'String',
      };
      newArray.push(payitnow_Ref);

      var payitnow_Currency = {
        id: newArray.length,
        Name: 'payitnow_Currency',
        Description: 'Pay it now Currency',
        Type: 'String',
      };
      newArray.push(payitnow_Currency);

      var payitnow_LastName = {
        id: newArray.length,
        Name: 'payitnow_LastName',
        Description: 'Pay it now Last name',
        Type: 'String',
      };
      newArray.push(payitnow_LastName);

      var payitnow_FirstName = {
        id: newArray.length,
        Name: 'payitnow_FirstName',
        Description: 'Pay it now First name',
        Type: 'String',
      };
      newArray.push(payitnow_FirstName);

      var payitnow_Value = {
        id: newArray.length,
        Name: 'payitnow_Value',
        Description: 'Pay it now Value',
        Type: 'String',
      };
      newArray.push(payitnow_Value);

      this.setState({ documentTypeConfigArray: newArray });
    } else {
      //remove the sage pay meta fields
      // create new array and re-assign ids on remove
      var newArray = [];
      var newid = 0;

      this.state.documentTypeConfigArray.forEach((documentTypeConfig, i) => {
        if (!documentTypeConfig.Name.startsWith('payitnow')) {
          var documentObj = {
            id: newid,
            Name: documentTypeConfig.Name,
            Description: documentTypeConfig.Description,
            Type: documentTypeConfig.Type,
          };
          newArray.push(documentObj);
          newid++;
        }
      });

      this.setState({ documentTypeConfigArray: newArray });
    }

    this.setState({
      includeSagePay: value,
    });
  };

  addParentHierarchy = () => {
    let parentHierarchies = [...this.state.parentHierarchies];

    parentHierarchies.push({});

    this.setState({
      parentHierarchies,
    });
  };

  removeParentHierarchy = (i) => {
    let parentHierarchies = [...this.state.parentHierarchies];

    parentHierarchies.pop(i);

    this.setState({
      parentHierarchies,
    });
  };

  addChildHierarchy = () => {
    let childHierarchies = [...this.state.childHierarchies];

    childHierarchies.push({});

    this.setState({
      childHierarchies,
    });
  };

  removeChildHierarchy = (i) => {
    let childHierarchies = [...this.state.childHierarchies];

    childHierarchies.pop(i);

    this.setState({
      childHierarchies,
    });
  };

  render() {
    let documentTypeConfigs = [];
    let fieldArrayList = [];
    let hierarchyList = [];
    let types = [];
    let folders = [];
    let loading = <div />;

    let doc_types = [];
    let parent_document_type_fields = [];
    let child_document_type_fields = [];

    let parent_hierarchies = [];
    let child_hierarchies = [];

    const { localisation } = this.props.userReducer;

    if (this.state.isLoading)
      loading = <Progress animated color="info" value={100} />;

    if (this.state.documentTypes)
      this.state.documentTypes.forEach((docType) => {
        if (this.state.hierarchyTypes) {
          doc_types.push(
            <option
              value={`${docType._id}!${docType.DocumentType}`}>
              {docType.Description.en}</option>)
        }
      });

    if (this.state.folders)
      this.state.folders.forEach((res) => {
        folders.push(<option>{res.DOSSIER}</option>);
      });

    if (this.state.documentArea == 'attachment') {
      this.state.parentHierarchies.map((hierarchy, i) => (
        parent_hierarchies.push(
        <>
          <Row form>
            <Col md={5}>
              <FormGroup>
                <Label for="name" className="s-field-title s-anchored">
                  {localisation['parent_document_type_text']
                    ? localisation['parent_document_type_text'].element_lang
                    : 'Parent Document Type'}
                </Label>
                <Input
                  type="select"
                  name={'docType'}
                  value={hierarchy && `${hierarchy.id}!${hierarchy.docType}`}
                  onChange={(e) => this.handleParentHierarchyChange(e, i)}
                >
                  <option value="">
                    {localisation['default_select_text']
                      ? localisation['default_select_text'].element_lang
                      : ''}
                  </option>
                  {doc_types}
                </Input>
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup check style={{ marginTop: '35px' }}>
                <Label
                  for="field_description"
                  className="s-field-title s-anchored"
                >
                  <Input
                    type="checkbox"
                    name={'includeAttachments'}
                    onClick={this.handleHierarchyCheckChange}
                    checked={hierarchy && hierarchy.includeAttachments}
                  />{' '}
                  Include in email
                </Label>
              </FormGroup>
            </Col>
          </Row>
        </>
     )))
     hierarchyList.push(
      <>
        {parent_hierarchies}
        <Button size="sm" color="success" onClick={() => this.addParentHierarchy()}>+</Button>
        <div style={{ marginBottom: '10px' }} />
        
      </>
    );
    } else {
      this.state.parentHierarchies.map((hierarchy, i) =>
        parent_hierarchies.push(
          <Row form>
            <Col md={4}>
              <FormGroup>
                <Label for="name" className="s-field-title s-anchored">
                  {localisation['parent_document_type_text']
                    ? localisation['parent_document_type_text'].element_lang
                    : 'Parent Document Type'}
                </Label>
                <Input
                  type="select"
                  name={'docType'}
                  onChange={(e) => this.handleParentHierarchyChange(e, i)}
                  value={hierarchy && `${hierarchy.id}!${hierarchy.docType}` }
                >
                  <option value="">
                    {localisation['default_select_text']
                      ? localisation['default_select_text'].element_lang
                      : ''}
                  </option>
                  {doc_types}
                </Input>
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label
                  for="field_description"
                  className="s-field-title s-anchored"
                >
                  {localisation['parent_field_name_text']
                    ? localisation['parent_field_name_text'].element_lang
                    : 'Parent Field Name'}
                </Label>
                <Input
                  type="select"
                  name={'field'}
                  onChange={(e) => this.handleParentHierarchyChange(e, i)}
                  value={hierarchy && hierarchy.id && hierarchy.docType && hierarchy.field ? `${hierarchy.id}!${hierarchy.docType}!${hierarchy.field}` : ''}
                >
                  <option value="">
                    {localisation['default_select_text']
                      ? localisation['default_select_text'].element_lang
                      : ''}
                  </option>
                  {hierarchy.docType &&
                    this.state.documentTypes
                      .filter((dt) => dt.DocumentType == hierarchy.docType)[0]
                      ?.Fields?.map((field) => (
                        <option value={hierarchy.id && hierarchy.docType && field.Name ? `${hierarchy.id}!${hierarchy.docType}!${field.Name}` : ''}>
                          {field.Description.en}
                        </option>
                      ))}
                </Input>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup check style={{ marginTop: '25px' }}>
                <Label
                  for="field_description"
                  className="s-field-title s-anchored"
                >
                  <Input
                    type="checkbox"
                    name={'includeAttachments'}
                    onClick={(e) => this.handleParentHierarchyCheckChange(e, i)}
                    checked={this.state.hierarchyTypes && this.state.hierarchyTypes['parentIncludeAttachments']}
                  />{' '}
                  Include in email
                </Label>
              </FormGroup>
            </Col>
            <Col md={1}>
              <FormGroup>
                <Button
                  id={i}
                  className="navbtn s-fonticon-btn"
                  outline
                  color="danger"
                  style={{ marginTop: '25px', padding: '3px 7px' }}
                  onClick={() => this.removeParentHierarchy(i)}
                >
                  
                </Button>
              </FormGroup>
            </Col>
          </Row>
        )
      );

      this.state.childHierarchies.map((hierarchy, i) =>
        child_hierarchies.push(
          <Row form>
            <Col md={4}>
              <FormGroup>
                <Label for="name" className="s-field-title s-anchored">
                  {localisation['child_document_type_text']
                    ? localisation['child_document_type_text'].element_lang
                    : 'Child Document Type'}
                </Label>
                <Input
                  type="select"
                  name={'docType'}
                  onChange={(e) => this.handleChildHierarchyChange(e, i)}
                  value={hierarchy && `${hierarchy.id}!${hierarchy.docType}`}
                >
                  <option value="">
                    {localisation['default_select_text']
                      ? localisation['default_select_text'].element_lang
                      : ''}
                  </option>
                  {doc_types}
                </Input>
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label
                  for="field_description"
                  className="s-field-title s-anchored"
                >
                  {localisation['child_field_name_text']
                    ? localisation['child_field_name_text'].element_lang
                    : 'Child Field Name'}
                </Label>
                <Input
                  type="select"
                  name={'field'}
                  onChange={(e) => this.handleChildHierarchyChange(e, i)}
                  value={hierarchy && hierarchy.id && hierarchy.docType && hierarchy.field ? `${hierarchy.id}!${hierarchy.docType}!${hierarchy.field}` : ''}
                >
                  <option value="">
                    {localisation['default_select_text']
                      ? localisation['default_select_text'].element_lang
                      : ''}
                  </option>
                  {hierarchy.docType &&
                    this.state.documentTypes
                      .filter((dt) => dt.DocumentType == hierarchy.docType)[0]
                      ?.Fields?.map((field) => (
                        <option value={hierarchy.id && hierarchy.docType && field.Name ? `${hierarchy.id}!${hierarchy.docType}!${field.Name}` : ''}>
                          {field.Description.en}
                        </option>
                      ))}
                </Input>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup check style={{ marginTop: '25px' }}>
                <Label
                  for="field_description"
                  className="s-field-title s-anchored"
                >
                  <Input
                    type="checkbox"
                    name={'includeAttachments'}
                    onClick={(e) => this.handleChildHierarchyCheckChange(e, i)}
                    checked={hierarchy && hierarchy.includeAttachments}
                  />{' '}
                  Include in email
                </Label>
              </FormGroup>
            </Col>
            <Col md={1}>
              <FormGroup>
                <Button
                  id={i}
                  className="navbtn s-fonticon-btn"
                  outline
                  color="danger"
                  style={{ marginTop: '25px', padding: '3px 7px' }}
                  onClick={() => this.removeChildHierarchy(i)}
                >
                  
                </Button>
              </FormGroup>
            </Col>
          </Row>
        )
      );

      hierarchyList.push(
        <>
          {parent_hierarchies}
          <Button
            size="sm"
            color="success"
            onClick={() => this.addParentHierarchy()}
          >
            +
          </Button>
          <div style={{ marginBottom: '10px' }} />
          {child_hierarchies}
          <Button
            size="sm"
            color="success"
            onClick={() => this.addChildHierarchy()}
          >
            +
          </Button>
        </>
      );
    }

    this.state.documentTypeConfigArray.forEach((documentTypeConfig, i) => {
      documentTypeConfigs = [];
      types = [];

      //set the known system types
      let fieldTypes = [
        '',
        'String',
        'Array',
        'Integer',
        'Boolean',
        'DateTime',
      ];

      //add the others for a user to edit.
      fieldTypes.forEach((fieldType) => {
        types.push(
          <option
            selected={fieldType == documentTypeConfig.Type}
            value={fieldType}
          >
            {fieldType}
          </option>
        );
      });

      if (documentTypeConfig.Name.startsWith('payitnow')) {
        fieldArrayList.push(
          <Row form>
            <Col md={4}>
              <FormGroup>
                <Label for="name" className="s-field-title s-anchored">
                  {localisation['field_name']
                    ? localisation['field_name'].element_lang
                    : ''}
                </Label>
                <Input
                  type="text"
                  disabled={true}
                  name={'Name'}
                  onChange={this.handlePrintDropdownChange}
                  value={documentTypeConfig.Name}
                  id={i}
                ></Input>
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label
                  for="field_description"
                  className="s-field-title s-anchored"
                >
                  {localisation['field_description']
                    ? localisation['field_description'].element_lang
                    : ''}
                </Label>
                <Input
                  type="text"
                  disabled={true}
                  name={'Description'}
                  onChange={this.handlePrintDropdownChange}
                  value={documentTypeConfig.Description}
                  id={i}
                ></Input>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Label for="Type" className="s-field-title s-anchored">
                  {localisation['field_type']
                    ? localisation['field_type'].element_lang
                    : ''}
                </Label>
                <Input
                  type="select"
                  disabled={true}
                  name={'Type'}
                  onChange={this.handlePrintDropdownChange}
                  id={i}
                >
                  {types}
                </Input>
              </FormGroup>
            </Col>
          </Row>
        );
      } else {
        fieldArrayList.push(
          <Row form>
            <Col md={4}>
              <FormGroup>
                <Label for="name" className="s-field-title s-anchored">
                  {localisation['field_name']
                    ? localisation['field_name'].element_lang
                    : ''}
                </Label>
                <Input
                  type="text"
                  name={'Name'}
                  onChange={this.handlePrintDropdownChange}
                  value={documentTypeConfig.Name}
                  id={i}
                ></Input>
              </FormGroup>
            </Col>
            <Col md={4}>
              <FormGroup>
                <Label
                  for="field_description"
                  className="s-field-title s-anchored"
                >
                  {localisation['field_description']
                    ? localisation['field_description'].element_lang
                    : ''}
                </Label>
                <Input
                  type="text"
                  name={'Description'}
                  onChange={this.handlePrintDropdownChange}
                  value={documentTypeConfig.Description}
                  id={i}
                ></Input>
              </FormGroup>
            </Col>
            <Col md={3}>
              <FormGroup>
                <Label for="Type" className="s-field-title s-anchored">
                  {localisation['field_type']
                    ? localisation['field_type'].element_lang
                    : ''}
                </Label>
                <Input
                  type="select"
                  name={'Type'}
                  onChange={this.handlePrintDropdownChange}
                  id={i}
                >
                  {types}
                </Input>
              </FormGroup>
            </Col>
            <Col md={1}>
              <FormGroup>
                <Button
                  id={i}
                  className="navbtn s-fonticon-btn"
                  outline
                  color="danger"
                  style={{ marginTop: '25px', padding: '3px 7px' }}
                  onClick={() => this.remove(i)}
                >
                  
                </Button>
              </FormGroup>
            </Col>
          </Row>
        );
      }
    });

    let documentTypeValidationModal = <div />;

    if (this.state.documentTypeValidationModalVisible)
      documentTypeValidationModal = (
        <DocumentTypeValidationModal
          documentType={this.state.documentType}
          folder={this.state.folder}
          visible={this.state.documentTypeValidationModalVisible}
          toggle={this.toggleDocumentTypeValidationModal}
        />
      );

    let alert_message = <div />;

    if (this.state.errorMessage)
      alert_message = <Alert color="danger">{this.state.errorMessage}</Alert>;

    return (
      <Modal
        isOpen={this.props.visible}
        toggle={this.props.toggle}
        className="modal-dialog"
      >
        <ModalHeader toggle={this.props.toggle}>
          {localisation['new_doc_config_header']
            ? localisation['new_doc_config_header'].element_lang
            : ''}
        </ModalHeader>
        <ModalBody>
          <FormGroup>
            {/* <Label for="documentType" className="s-field-title s-anchored">{localisation['table_header_type'] ? localisation['table_header_type'].element_lang : ''}</Label>
                <Input type="text" name={"documentType"} onChange={this.handleDropdownChange} id={"documentType"}>
                </Input> */}
            <ValidatedTextBox
              isEnabled={true}
              id="documentType"
              labelText={
                localisation['table_header_type']
                  ? localisation['table_header_type'].element_lang
                  : 'Document Type'
              }
              onChange={this.handleDropdownChange}
              mandatory={true}
              value={this.state.documentType}
            />
          </FormGroup>
          <FormGroup>
            <Label for="folder" className="s-field-title s-anchored">
              {localisation['table_header_folder']
                ? localisation['table_header_folder'].element_lang
                : ''}
            </Label>
            <Input
              type="select"
              name={'folder'}
              onChange={this.handleFolderDropdownChange}
              id={'folder'}
            >
              {folders}
            </Input>
          </FormGroup>
          <FormGroup>
            {/* <Label for="description" className="s-field-title s-anchored">{localisation['table_header_desc'] ? localisation['table_header_desc'].element_lang : ''}</Label>
                <Input type="text" name={"description"} onChange={this.handleDropdownChange} id={"description"}>
                </Input> */}
            <ValidatedTextBox
              isEnabled={true}
              id="description"
              labelText={
                localisation['table_header_desc']
                  ? localisation['table_header_desc'].element_lang
                  : 'Description'
              }
              onChange={this.handleDropdownChange}
              mandatory={true}
              value={this.state.description}
            />
          </FormGroup>
          <FormGroup>
            {/* <Label for="transaction_type" className="s-field-title s-anchored">{localisation['table_header_tran'] ? localisation['table_header_tran'].element_lang : ''}</Label>
                <Input type="text" name={"transaction_type"} onChange={this.handleDropdownChange} id={"transaction_type"}>
                </Input> */}
            <ValidatedTextBox
              isEnabled={true}
              id="transaction_type"
              labelText={
                localisation['table_header_tran']
                  ? localisation['table_header_tran'].element_lang
                  : 'Transaction Type'
              }
              onChange={this.handleDropdownChange}
              mandatory={true}
              value={this.state.transaction_type}
            />
          </FormGroup>
          <FormGroup>
            <Label for="document_area" className="s-field-title s-anchored">
              {localisation['table_header_doc_area']
                ? localisation['table_header_doc_area'].element_lang
                : 'Document Area'}
            </Label>
            <Input
              type="select"
              name={'document_area'}
              onChange={this.handleDocumentAreaDropdownChange}
              value={this.state.documentArea}
            >
              <option value={'x3'}>X3 Report</option>
              <option value={'attachment'}>Document Attachment</option>
              <option value={'scan'}>Scanned Document</option>
              <option value={'ocr'}>OCR Document</option>
            </Input>
          </FormGroup>
          {this.state.documentArea == 'scan' && (
            <Flag flag="DisplayScanID" entity={{ id: 1 }} case="on">
              <FormGroup>
                <ValidatedTextBox
                  isEnabled={true}
                  id="scan_id"
                  labelText={
                    localisation['table_header_scan_id']
                      ? localisation['table_header_scan_id'].element_lang
                      : 'Scan ID'
                  }
                  onChange={this.handleDropdownChange}
                  mandatory={true}
                  value={this.state.scan_id}
                />
              </FormGroup>
            </Flag>
          )}
          <header class="s-h2-head-search">
            <div title="Hierarchy" class="s-h2-title">
              Document Hierarchy
            </div>
          </header>
          {hierarchyList}
          <header class="s-h2-head-search">
            <div title="MetaFields" class="s-h2-title">
              {localisation['meta_fields_text']
                ? localisation['meta_fields_text'].element_lang
                : ''}
            </div>
          </header>
          <FormGroup check style={{ marginTop: '25px' }}>
            <Label for="includeSagePay" className="s-field-title s-anchored">
              <Input
                type="checkbox"
                name={'includeSagePay'}
                onClick={this.includeSagePayCheckChange}
                checked={this.state.includeSagePay}
              />{' '}
              Include Sage Pay
            </Label>
          </FormGroup>
          {fieldArrayList}
          {loading}
          {alert_message}
        </ModalBody>
        <ModalFooter>
          <Button
            color="success"
            style={{ position: 'absolute', left: '20px' }}
            onClick={this.toggleDocumentTypeConfigModal}
          >
            {localisation['add_field_button']
              ? localisation['add_field_button'].element_lang
              : ''}
          </Button>
          <Button
            color="primary"
            style={{ position: 'absolute', left: '140px' }}
            onClick={this.toggleDocumentTypeValidationModal}
          >
            {localisation['test_document_button']
              ? localisation['test_document_button'].element_lang
              : 'Test Document'}
          </Button>
          <Button color="primary" onClick={this.validateDocumemtType}>
            {localisation['save_button']
              ? localisation['save_button'].element_lang
              : ''}
          </Button>
          <Button color="secondary" onClick={this.props.toggle}>
            {localisation['cancel_button']
              ? localisation['cancel_button'].element_lang
              : ''}
          </Button>
        </ModalFooter>
        {documentTypeValidationModal}
      </Modal>
    );
  }
}

export default connect((state) => state)(
  withAlert()(NewDocumentTypeConfigModal)
);
